import { FC, SVGProps } from 'react';

export const BoldIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7.25 5C7.25 4.58579 7.58579 4.25 8 4.25H17.2618C20.8674 4.25 23.1584 8.10927 21.4318 11.2745L20.1861 13.5585C20.0739 13.7641 20.2301 14.0132 20.464 14.0018L20.5 14C23.1234 14 24.75 16.1544 24.75 18.7778V23C24.75 25.6234 22.6234 27.75 20 27.75H8C7.58579 27.75 7.25 27.4142 7.25 27V5ZM18.0434 14.0278C18.1531 14.0278 18.2542 13.9678 18.3067 13.8714L20.115 10.5563C21.2963 8.39055 19.7288 5.75 17.2618 5.75H9.05C8.88431 5.75 8.75 5.88431 8.75 6.05V13.7278C8.75 13.8935 8.88432 14.0278 9.05 14.0278H18.0434ZM9.05 15.5278C8.88431 15.5278 8.75 15.6621 8.75 15.8278V25.95C8.75 26.1157 8.88432 26.25 9.05 26.25H20C21.7949 26.25 23.25 24.7949 23.25 23V18.7778C23.25 16.9829 21.7949 15.5278 20 15.5278H9.05Z"
			fill="currentColor"
		/>
	</svg>
);
